import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import validator from "email-validator";
import { useDispatch, useSelector } from "react-redux";
import { TransparentButton, SolidButton } from "../../../../library/button";
import {
  changeCompanyModal,
  requestSendInvitation,
} from "../../../../../redux/actions/company";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import { ToastContainer } from "react-toastify";
import { Input } from "../../../../library/input";
import { Popup } from "../../../../library/popup";
import { Label } from "../../../../library/label";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const modalState = useSelector((state) => state.company.showModals.addMember);

  const loading = useSelector((state) => state.company.sendInvitation.loading);

  const companyDetails = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany
  );

  const handleClose = () => {
    dispatch(changeCompanyModal({ addMember: false }));
  };

  const clickSendInvitation = () => {
    if (email && validator.validate(email)) {
      dispatch(
        requestSendInvitation({
          companyId: companyDetails.id,
          email: email,
          companyName: companyDetails.name,
        })
      );
    } else {
      sendErrorNotification("Vennligst oppgi en gyldig e-post.");
    }
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Legg til ansatt"
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={loading ? "Sender.." : "Send invitasjon"}
          icon={
            loading ? (
              <i className="fas fa-circle-notch fa-spin"></i>
            ) : (
              <i className="fas fa-plus"></i>
            )
          }
          onClick={() => clickSendInvitation()}
          type="button"
        />,
      ]}
    >
      <div className="invite-member-content-container">
        <Row className="invite-row">
          <Col className="invite-col">
            <Label version={1} weight="bold">
              E-post
            </Label>
            <Input
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="E-post"
            />
            <p className="invite-info">
              Invitasjonen vil være gyldig i 24 timer fra den sendes.
            </p>
          </Col>
        </Row>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
